import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { FormScriptResponse } from '~/models/Commons ';
import { RootState } from '~/store/index';

interface State {
    scripts: FormScriptResponse[];
     authenticated: boolean;
}

const initialState: State = {
    scripts: [],
    authenticated:false
};

const ScriptSlice = createSlice({
    name: 'script',
    initialState,
    reducers: {
        SET_SCRIPTS(state, { payload }: PayloadAction<FormScriptResponse[]>) {
            state.scripts = payload;
        },
            DELETE_SCRIPT_BYID(state, { payload }: PayloadAction<string>) {
            if (!Array.isArray(state.scripts)) {
                state.scripts = []; // Ensure it's an array
            }

            state.scripts = state.scripts.map(item =>
                item.scriptIdentify.deploymentScriptId!== payload ? item : { ...item, active: false }
            );
        },

        ADD_SCRIPT(state, { payload }: PayloadAction<FormScriptResponse>) {
            const newScripts = [...state.scripts, payload];
            state.scripts = newScripts;
        },
        PATCH_SCRIPT(state, { payload }: PayloadAction<FormScriptResponse>) {
            const newScripts = [...state.scripts];
            const findInd = newScripts.findIndex(({ id }) => id === payload.id);
            if (findInd < 0) return;

            newScripts[findInd] = { ...payload };
            state.scripts = newScripts;
        },
         SET_AUTHENTICATED(state, { payload }: PayloadAction<boolean>) {
            state.authenticated = payload;
        },
    },
});

export const selectScript = (state: RootState) => state.script;

export const { SET_SCRIPTS, DELETE_SCRIPT_BYID, ADD_SCRIPT, PATCH_SCRIPT,SET_AUTHENTICATED } =
    ScriptSlice.actions;

export default ScriptSlice.reducer;
